import { getDroplink, getCheckbox } from '@/shared/param-utils';
import { useConditionalRendering } from '@/shared/useConditionalRendering';
import { CtaContentCardProps } from '@ahc-digital/component-library';
import { C20CTAContentCardProps } from './C20CTAContentCard.types';

export function CreateCTAContentCardModel(props?: C20CTAContentCardProps) {
  type t = CtaContentCardProps;
  const { params, fields } = props || {};
  const { renderRichText, renderImage, renderLink, renderText } = useConditionalRendering();
  return {
    headline: renderText(fields?.Headline),
    supportCopy: renderRichText(fields?.SupportCopy),
    firstCta: renderLink(fields?.FirstCTA),
    secondCta: renderLink(fields?.SecondCTA),
    thirdCta: renderLink(fields?.ThirdCTA),
    image: renderImage(fields?.Image),
    headlineTag: getDroplink<t['headlineTag']>(params?.HeadlineTag, 'p'),
    firstCtaStyle: getDroplink<t['firstCtaStyle']>(params?.FirstCTAStyle, 'button'),
    secondCtaStyle: getDroplink<t['secondCtaStyle']>(params?.SecondCTAStyle, 'button'),
    ctaAlignment: getDroplink<t['ctaAlignment']>(params?.CTAAlignment, 'center'),
    shouldLazyLoad: getCheckbox(params?.ShouldLazyLoad),
  };
}
